import React from "react";
import { FaTimes } from "react-icons/fa";

class RemovableLabel extends React.Component {
  render() {
    const {
      onClick,
      text,
      textColor,
      bgColor,
      hint = "Remove",
      iconOnly = true,
    } = this.props;

    const colonIndex = text.indexOf(":");
    const title = colonIndex > -1 ? text.substring(0, colonIndex) : text;
    const body = colonIndex > -1 ? text.substring(colonIndex + 1) : null;

    const contentElement = iconOnly ? (
      text
    ) : (
      <>
        {title}:{" "}
        {onClick && (
          <div
            className="inline-block cursor-pointer px-2 text-blue-600 hover:text-blue-700"
            onClick={onClick}
          >
            [{hint}]
          </div>
        )}
        {body && <div>{body}</div>}
      </>
    );

    return (
      <div className={`flex items-center gap-2 ${bgColor} rounded px-2 py-1`}>
        {iconOnly && (
          <button
            type="button"
            className={`text-xs text-blue-600 hover:text-blue-700`}
            onClick={onClick}
          >
            <div className="flex items-center">
              [<FaTimes></FaTimes>]
            </div>
          </button>
        )}

        <div
          className={`flex-1 overflow-y-auto break-all text-sm leading-4 ${textColor}`}
          style={{ maxHeight: "6rem" }}
        >
          {contentElement}
        </div>
      </div>
    );
  }
}
export default RemovableLabel;
